import { render, staticRenderFns } from "./questionTypeBadge.vue?vue&type=template&id=62febec0&scoped=true"
import script from "./questionTypeBadge.vue?vue&type=script&lang=js"
export * from "./questionTypeBadge.vue?vue&type=script&lang=js"
import style0 from "./questionTypeBadge.vue?vue&type=style&index=0&id=62febec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62febec0",
  null
  
)

export default component.exports